module.exports = __webpack_public_path__ + "static/media/upi.b1dbf1b2.svg";